module.exports = __webpack_public_path__ + "static/img/u1.a920389e.png";